import {Box, HStack, Icon, Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import {MY_DAY_PREVIEW_DATA, MyDayView} from '@dms/features/interest-recommendations';
import i18n from '@dms/i18n';

export function InterestMyDay() {
  const [data, setData] = useState(MY_DAY_PREVIEW_DATA);

  return (
    <VStack spacing={6}>
      <MyDayView
        contextKey="my-day-preview"
        data={data}
        status="ready"
        isPreview
        onRefresh={() => setData({...MY_DAY_PREVIEW_DATA})}
      />
      <Box paddingHorizontal={1} paddingBottom={4}>
        <HStack spacing={2} align="center">
          <Icon value="action/info_outline" size={3} color="text.tertiary" />
          <Text size="xSmall" color="tertiary">
            {i18n.t('page.interestMyDay.preview.notice')}
          </Text>
        </HStack>
      </Box>
    </VStack>
  );
}
